import React from "react";
import { Edit2 } from "@piiqtechnologies/svg-icons";
import { TableActionButton } from "@common-components/table";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import { Policy } from "@piiqtechnologies/ui-lib";
export const SpaceEditAction = ({ onEdit, disabled = false }) => {
    const intl = useIntl();
    return (React.createElement(Policy, { action: "Space_Edit" /* PolicyActions.SPACE_EDIT */, mode: "hide" },
        React.createElement(TableActionButton, { "aria-label": intl.formatMessage(messages.actionsEdit), Icon: Edit2, tooltip: intl.formatMessage(messages.actionsEdit), onClick: onEdit, disabled: disabled })));
};
export default SpaceEditAction;
